// import { checkPhase } from 'utils/checkPhase';
// import Print from 'assets/icons/printer.svg';
// import Heart from 'assets/icons/heart.svg';
// import HeartFilled from 'assets/icons/heart-filled.svg';
import AddToCompare from '@templates/AddToCompare';
import AddToCompareIcon from '@templates/AddToCompareIcon';

import classes from './ActionsOnTop.module.scss';

type Props = {
  id: number;
  productTypeId: number;
  // eslint-disable-next-line react/no-unused-prop-types
  isFavorite: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  onFavorite?: () => void;
};

const ActionsOnTop = ({ id, productTypeId }: Props): JSX.Element => (
  // const IconComponent = isFavorite ? HeartFilled : Heart;

  <div className={classes.wrapper}>
    <div className={classes.itemWrapper}>
      {/* {checkPhase(2) && (
          <div
            onClick={() => {
              window.print();
            }}
            className={classes.iconWrapper}
          >
            <Print className={classes.icon} />
          </div>
        )}
        {checkPhase(2) && (
          <div onClick={onFavorite} className={classes.iconWrapper}>
            <IconComponent className={classes.icon} />
          </div>
        )} */}
    </div>
    <div className={classes.compareMobile}>
      <AddToCompareIcon id={id} productTypeId={productTypeId} />
    </div>
    <div className={classes.compare}>
      <AddToCompare id={id} productTypeId={productTypeId} />
    </div>
  </div>
);
export default ActionsOnTop;
